const PDP_MEDIA_NAVIGATION_LEFT_OFFSET = 24
// ADDNEWCOLORPROCESS
const bundleColorValues = ['Charcoal', 'Petal', 'Lavender', 'Sand', 'Terracotta', 'Pacific', 'Eucalyptus', '5PM', '6PM', '7PM', 'Arctic', 'Atlantic', 'Pine', 'Sage','Blush', 'Rosa', 'Plum', 'Almond', 'Clay', 'Mocha', 'Cacao', 'Periwinkle', 'Iris','Renew','PetalBlush','BlushTerra','TerraPetal', 'Sherbet', 'Santorini', 'Heart','Mocha5PMClay','SageMochaAlmond','5PMSageCacao','MochaMochaPetal', 'Slate', 'Berry', 'Pearl', 'Granite','Cobalt'];
const limitedEditionColors = ['Blush', 'Rosa', 'Plum'];

const isLabelForPreorder = (label) => ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'].includes(label);
// NEWBY4
const isBuildYour = (label) => [
  'build-your-6',
  'build-your-12',
  'the-132-set-of-4',
  'the-132-set-of-4-sm',
  'the-132-set-of-5',
  'the-132-set-of-8',
  'the-132-set-of-2',
  'the-132-set-of-3',
  'the-132-set-of-3-sm',
  'the-132-set-of-9',
  'the-132-set-of-7',
  'build-your-6-fp',
  'build-your-12-fp',
  
  'the-132-set-of-7-2',
  'build-your-6-special-edition',
  'build-your-5',
  'build-your-4',
  'build-your-8',
  'build-your-3',
  'build-your-9',
  'the-132-set-of-6',
  'the-132-set-of-7-fp',
  'the-132-set-of-7-parcel',
].includes(label);

const isLabelBuild = (label) => ['3-tile-bundle', '6-tile-bundle', 'the-flex-tile-set-of-7', '12-tile-bundle'].includes(label);
const isArakiProduct = (label) => ['capsules-araki', 'tiles-araki'].includes(label);
const isCorporateGifting = $('html').hasClass('page-corporate_gifts');
const stdIcons = ['5PM-icon', '6PM-icon', '7PM-icon', 'choice-icon', 'heart-icon', 'pills-icon', 'sun-icon', 'rainbow-icon', 'lips-icon', 'jewelry-icon', 'liquid-icon', 'arctic-icon', 'pacific-icon', 'atlantic-icon', 'sage-icon', 'pine-icon', 'eucalyptus-icon', 'eye-icon', 'leaf-icon'];
const isArakiIcon = (label) => arakiIcons.includes(label);
const isGoldenHour = (label) => ['5PM', '6PM', '7PM'].includes(label);
const arakiIcons = ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'];
const isBaS = $('html').hasClass('page-build_a_system') || $('html').hasClass('page-lifeproof_flow');
const isBaSHandle = (handle) => ['build-a-system', 'build-a-system-new'].includes(handle)
const isCorporateGifts = (handle) => handle === 'corporate-gifts';
// BASDISCOUNTUPDATES
const BaSDiscountRules = [
  // { minPrice: 150, discount: 25, text: "You’re saving $25 and getting free US ground shipping" },
  // { minPrice: 125, discount: 15, text: "You’re saving $15 on your System and getting free US ground shipping" },
];
const canUseImageService = (boxesColor, handle) => boxesColor.length && (isBuildYour(handle) || isLabelBuild(handle) || isCorporateGifts(handle));

// LANDINGPAGES2024 -- dynamic capsule availablity

const dynaCapsuleHandles = [
  'the-132-set-of-7-fp',
  'the-132-set-of-7-parcel', 
  'the-132-set-of-6',
  'the-132-set-of-4',
  'the-132-set-of-4-sm',
  // 'the-132-set-of-5',
  'the-132-set-of-3',
  'the-132-set-of-3-sm',
  'the-132-set-of-2',
  'the-132-set-of-7',
  'honeycomb-duplicate',
  'build-your-6',
  'build-your-12'
]
const isDynaCapsuleBundle = (handle) => dynaCapsuleHandles.includes(handle);
const canUseDynaCapsule = (boxesColor, handle) => {
  if (dynaCapsuleHandles.includes(handle) && boxesColor.length) {
    return true
  }
  return false
};

const imageServiceParams = (handle) => {
  // NEWBY4
  const typeParam = (() => {
    if (
      handle === 'the-132-set-of-7'  
      || handle === 'the-132-set-of-7-2'
      || handle === 'the-132-set-of-6'
      || handle === 'the-132-set-of-7-fp'
      || handle === 'the-132-set-of-7-parcel'
      || handle === 'the-132-set-of-2'
      || handle === 'the-132-set-of-3' 
      || handle === 'the-132-set-of-4'
      || handle === 'the-132-set-of-4-sm'
      || handle === 'the-132-set-of-3-sm'
      || handle === 'the-132-set-of-5'
      || handle === 'the-132-set-of-8' 
      || handle === 'the-132-set-of-9'
      ) return 'type=the-132-build&'
    return isBuildYour(handle) || isCorporateGifts(handle) ? 'type=build&' : 'type=label-bundle&'
  })()
  const isCorporate = isCorporateGifts(handle) ? '&is_corporate=true' : ''
  return { typeParam, isCorporate }
}
const isIcon = (label) => [...stdIcons, ...arakiIcons].includes(label?.trim());
const isCustomize = (el) => $(el).closest('.label-block').find('.premade-labels .selectize-control .item').hasClass('user-created-tag')
const isCustomImage = (label) => label?.includes('Custom Logo');
const starterLabelSelectizeUserCreatedTagClass = 'user-created-tag'
const starterLabelSelectizeBaSPlugin = 'nodeselect'
const maxCustomLabelLength = 22
const placeholderOnLebelSelectizeOpen = "Start typing..."

// Remove emojis
window.addEventListener('load', function() {
  $('input[type="select-one"]').on('input', function() {
    const str = $(this).val();
    const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF][\uDC00-\uDFFF])/g;
    $(this).val(str.replace(emojiRegex, ''));
  });
  $('input[type="select-one"]').attr(
    'pattern',
    '^[^\\u1F600-\\u1F64F\\u1F300-\\u1F5FF\\u1F680-\\u1F6FF\\u2600-\\u26FF\\u1F900-\\u1F9FF]*$'
  );
});

const sizeBySizeName = {
  'the 56': 'small',
  'the 132': 'medium',
  'the 275': 'large',
  'small': 'small',
  'medium': 'medium',
  'large': 'large'
}
const sizeNameByValue = {
  'the 56': 'small',
  'the 132': 'medium',
  'the 275': 'large',
  'small': 'small',
  'medium': 'medium',
  'large': 'large'
   }
// ADDNEWCOLORPROCESS 'Sherbet', 'Santorini', 'Heart'
const typingWords = ['type anything', '<div>toothpaste</div><div>tablets</div>', 'hyaluronic acid', 'alex', 'face serum'];
const colorNames = ['Charcoal', 'Petal', 'Lavender', 'Sand', 'Terracotta', 'Pacific', 'Arctic', 'Atlantic', 'Pine', 'Sage', 'Eucalyptus', '5PM', '6PM', '7PM', 'Blush', 'Rosa', 'Plum', 'Almond', 'Clay', 'Mocha', 'Cacao', 'Periwinkle', 'Iris','Renew','PetalBlush','BlushTerra','TerraPetal', 'Sherbet', 'Santorini', 'Heart','Mocha5PMClay','SageMochaAlmond','5PMSageCacao','MochaMochaPetal','Slate', 'Berry', 'Pearl', 'Granite','Cobalt'];
const labelColors = [
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black', 
  'black',
  'black',
  'black', 
  'white',
  'black', 
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'black',
  'white',
  'white'
];
// ADDNEWCOLORPROCESS 'Sherbet', 'Santorini', 'Heart'
const labelColorsByColor = {
  Charcoal: 'black',
  Petal: 'black',
  Lavender: 'black',
  Sand: 'black',
  Terracotta: 'black',
  Arctic: 'black',
  Pacific: 'black',
  Atlantic: 'black',
  Pine: 'black',
  Sage: 'black',
  Eucalyptus: 'black',
  "5PM": 'black',
  "6PM": 'black',
  "7PM": 'black',
  "Blush": 'black',
  "Rosa": 'black',
  "Plum": 'black',
  "Almond": 'black',
  "Clay": 'black',
  "Mocha": 'black',
  "Cacao": 'white',
  "Periwinkle": 'black',
  "Iris": 'black',
  "Renew": 'black',
  "PetalBlush": 'black',
  "BlushTerra": 'black',
  "TerraPetal": 'black',
  "Sherbet": 'black',
  "Santorini": 'black',
  "Heart": 'black',
  "Mocha5PMClay": 'black',
  "SageMochaAlmond": 'black',
  "5PMSageCacao": 'black',
  "MochaMochaPetal": 'black',
  "Slate": 'black',
  "Berry": 'black',
  "Pearl": 'black',
  "Granite": 'black',
  "Cobalt": 'white'
};
let typingAnimating = false;
let mainGallerySwiper = null;
let yotpoInterval = null
const yotpoIntervalTimeout = 2000
const isMobile = $(window).width() < 640;

const localStorageKeys = {
  BAS: {
    NUMBER_OF_CAPSULES: "bas-number_of_capsules",
    COLOR: "bas-color",
    LABELS: "bas-labels",
    CAPSULES: "bas-capsules"
  }
}

const SHADOW_CAPSULES = {
  production: {
    large: {
      charcoal: {id: 40507957280853, sku: "Char-Larg-Capsule-01"},
      petal: {id: 40507957313621, sku: "Petl-Larg-Capsule-01"},
      lavender: {id: 40507957346389, sku: "Lav-Larg-Capsule-01"},
      sand: {id: 40507957379157, sku: "Sand-Larg-Capsule-01"},
      terracotta: {id: 40507957411925, sku: "Terra-Larg-Capsule-01"},
      pacific: {id: 40507957444693, sku: "Pac-Larg-Capsule-01"},
      arctic: {id: 40507957477461, sku: "Arc-Larg-Capsule-01"},
      atlantic: {id: 40507957510229, sku: "Atl-Larg-Capsule-01"},
      pine: {id: 40507957542997, sku: "Pine-Larg-Capsule-01"},
      sage: {id: 40507957575765, sku: "Sage-Larg-Capsule-01"},
      eucalyptus: {id: 40507957608533, sku: "Euca-Larg-Capsule-01"},
      '5pm': {id: 40507957641301, sku: "5PM-Larg-Capsule-01"},
      '6pm': {id: 40507957674069, sku: "6PM-Larg-Capsule-01"},
      '7pm': {id: 40507957706837, sku: "7PM-Larg-Capsule-01"},
      blush: {id: 40700819865685, sku: "Blush-Larg-Capsule-01"},
      rosa: {id: 40700819898453, sku: "Rosa-Larg-Capsule-01"},
      plum: {id: 40700819931221, sku: "Plum-Larg-Capsule-01"},
      almond: {id: 40724161298517, sku: "Almond-Larg-Capsule-01"},
      clay: {id: 40724161331285, sku: "Clay-Larg-Capsule-01"},
      mocha: {id: 40724161364053, sku: "Mocha-Larg-Capsule-01"},
      cacao: {id: 40724161396821, sku: "Cacao-Larg-Capsule-01"},

    },
    medium: {
      charcoal: {id: 40507940831317, sku: "Char-Med-Capsule-01"},
      petal: {id: 40507940864085, sku: "Petl-Med-Capsule-01"},
      lavender: {id: 40507940896853, sku: "Lav-Med-Capsule-01"},
      sand: {id: 40507940929621, sku: "Sand-Med-Capsule-01"},
      terracotta: {id: 40507940962389, sku: "Terra-Med-Capsule-01"},
      pacific: {id: 40507940995157, sku: "Pac-Med-Capsule-01"},
      arctic: {id: 40507941027925, sku: "Arc-Med-Capsule-01"},
      atlantic: {id: 40507941060693, sku: "Atl-Med-Capsule-01"},
      pine: {id: 40507941093461, sku: "Pine-Med-Capsule-01"},
      sage: {id: 40507941126229, sku: "Sage-Med-Capsule-01"},
      eucalyptus: {id: 40507941158997, sku: "Euca-Med-Capsule-01"},
      '5pm': {id: 40507941191765, sku: "5PM-Med-Capsule-01"},
      '6pm': {id: 40507941224533, sku: "6PM-Med-Capsule-01"},
      '7pm': {id: 40507941257301, sku: "7PM-Med-Capsule-01"},
      blush: {id: 40700804464725, sku: "Blush-Med-Capsule-01"},
      rosa: {id: 40700804497493, sku: "Rosa-Med-Capsule-01"},
      plum: {id: 40700804530261, sku: "Plum-Med-Capsule-01"},
      almond: {id: 40724161036373, sku: "Almond-Med-Capsule-01"},
      clay: {id: 40724161069141, sku: "Clay-Med-Capsule-01"},
      mocha: {id: 40724161101909, sku: "Mocha-Med-Capsule-01"},
      cacao: {id: 40724161134677, sku: "Cacao-Med-Capsule-01"},

    },
    mini: {
      charcoal: {id: 40507938996309, sku: "Char-Min-Capsule-01"},
      petal: {id: 40507939029077, sku: "Petl-Min-Capsule-01"},
      lavender: {id: 40507939061845, sku: "Lav-Min-Capsule-01"},
      sand: {id: 40507939094613, sku: "Sand-Min-Capsule-01"},
      terracotta: {id: 40507939127381, sku: "Terra-Min-Capsule-01"},
      pacific: {id: 40507939160149, sku: "Pac-Min-Capsule-01"},
      arctic: {id: 40507939192917, sku: "Arc-Min-Capsule-01"},
      atlantic: {id: 40507939225685, sku: "Atl-Min-Capsule-01"},
      pine: {id: 40507939258453, sku: "Pine-Min-Capsule-01"},
      sage: {id: 40507939291221, sku: "Sage-Min-Capsule-01"},
      eucalyptus: {id: 40507939323989, sku: "Euca-Min-Capsule-01"},
      '5pm': {id: 40507939356757, sku: "5PM-Min-Capsule-01"},
      '6pm': {id: 40507939389525, sku: "6PM-Min-Capsule-01"},
      '7pm': {id: 40507939422293, sku: "7PM-Min-Capsule-01"},
      blush: {id: 40700836675669, sku: "Blush-Min-Capsule-01"},
      rosa: {id: 40700836708437, sku: "Rosa-Min-Capsule-01"},
      plum: {id: 40700836741205, sku: "Plum-Min-Capsule-01"},
      almond: {id: 40724156252245, sku: "Almond-Min-Capsule-01"},
      clay: {id: 40724156285013, sku: "Clay-Min-Capsule-01"},
      mocha: {id: 40724156317781, sku: "Mocha-Min-Capsule-01"},
      cacao: {id: 40724156350549, sku: "Cacao-Min-Capsule-01"},
    },
    small: {
      charcoal: {id: 40519143424085, sku: "Char-Disc-Capsule-01"},
      petal: {id: 40519143456853, sku: "Petl-Disc-Capsule-01"},
      lavender: {id: 40519143489621, sku: "Lav-Disc-Capsule-01"},
      sand: {id: 40519143522389, sku: "Sand-Disc-Capsule-01"},
      terracotta: {id: 40519143555157, sku: "Terra-Disc-Capsule-01"},
      pacific: {id: 40519143587925, sku: "Pac-Disc-Capsule-01"},
      arctic: {id: 40519143620693, sku: "Arc-Disc-Capsule-01"},
      atlantic: {id: 40519143653461, sku: "Atl-Disc-Capsule-01"},
      pine: {id: 40519143686229, sku: "Pine-Disc-Capsule-01"},
      sage: {id: 40519143718997, sku: "Sage-Disc-Capsule-01"},
      eucalyptus: {id: 40519143751765, sku: "Euca-Disc-Capsule-01"},
      '5pm': {id: 40519143784533, sku: "5PM-Disc-Capsule-01"},
      '6pm': {id: 40519143817301, sku: "6PM-Disc-Capsule-01"},
      '7pm': {id: 40519143850069, sku: "7PM-Disc-Capsule-01"},
      blush: {id: 40700780675157, sku: "Blush-Disc-Capsule-01"},
      rosa: {id: 40700780707925, sku: "Rosa-Disc-Capsule-01"},
      plum: {id: 40700780740693, sku: "Plum-Disc-Capsule-01"},
      almond: {id: 40724161593429, sku: "Almond-Disc-Capsule-01"},
      clay: {id: 40724161626197, sku: "Clay-Disc-Capsule-01"},
      mocha: {id: 40724161658965, sku: "Mocha-Disc-Capsule-01"},
      cacao: {id: 40724161691733, sku: "Cacao-Disc-Capsule-01"},
    }
  },
  staging: {
    large: {
      charcoal: {id: 44429367116071, sku: "Char-Larg-Capsule-01"},
      petal: {id: 44429367148839, sku: "Petl-Larg-Capsule-01"},
      lavender: {id: 44429367181607, sku: "Lav-Larg-Capsule-01"},
      sand: {id: 44429367214375, sku: "Sand-Larg-Capsule-01"},
      terracotta: {id: 44429367247143, sku: "Terra-Larg-Capsule-01"},
      pacific: {id: 44429367279911, sku: "Pac-Larg-Capsule-01"},
      arctic: {id: 44429367312679, sku: "Arc-Larg-Capsule-01"},
      atlantic: {id: 44429367345447, sku: "Atl-Larg-Capsule-01"},
      pine: {id: 44429367378215, sku: "Pine-Larg-Capsule-01"},
      sage: {id: 44429367410983, sku: "Sage-Larg-Capsule-01"},
      eucalyptus: {id: 44429367443751, sku: "Euca-Larg-Capsule-01"},
      '5pm': {id: 44429367476519, sku: "5PM-Larg-Capsule-01"},
      '6pm': {id: 44429367509287, sku: "6PM-Larg-Capsule-01"},
      '7pm': {id: 44429367542055, sku: "7PM-Larg-Capsule-01"},
      blush: {id: 40700780675157, sku: "Blush-Larg-Capsule-01"},
      rosa: {id: 40700780707925, sku: "Rosa-Larg-Capsule-01"},
      plum: {id: 40700780740693, sku: "Plum-Larg-Capsule-01"},
    },
    medium: {
      charcoal: {id: 44429363511591, sku: "Char-Med-Capsule-01"},
      petal: {id: 44429363544359, sku: "Petl-Med-Capsule-01"},
      lavender: {id: 44429363577127, sku: "Lav-Med-Capsule-01"},
      sand: {id: 44429363609895, sku: "Sand-Med-Capsule-01"},
      terracotta: {id: 44429363642663, sku: "Terra-Med-Capsule-01"},
      pacific: {id: 44429363708199, sku: "Pac-Med-Capsule-01"},
      arctic: {id: 44429363740967, sku: "Arc-Med-Capsule-01"},
      atlantic: {id: 44429363773735, sku: "Atl-Med-Capsule-01"},
      pine: {id: 44429363806503, sku: "Pine-Med-Capsule-01"},
      sage: {id: 44429363839271, sku: "Sage-Med-Capsule-01"},
      eucalyptus: {id: 44429363872039, sku: "Euca-Med-Capsule-01"},
      '5pm': {id: 44429363904807, sku: "5PM-Med-Capsule-01"},
      '6pm': {id: 44429363937575, sku: "6PM-Med-Capsule-01"},
      '7pm': {id: 44429363970343, sku: "7PM-Med-Capsule-01"},
      blush: {id: 44429363970343, sku: "7PM-Med-Capsule-01"},
      rosa: {id: 44429363970343, sku: "7PM-Med-Capsule-01"},
      plum: {id: 44429363970343, sku: "7PM-Med-Capsule-01"},
    },
    mini: {
      charcoal: {id: 44429356073255, sku: "Char-Min-Capsule-01"},
      petal: {id: 44429356106023, sku: "Petl-Min-Capsule-01"},
      lavender: {id: 44429356138791, sku: "Lav-Min-Capsule-01"},
      sand: {id: 44429356171559, sku: "Sand-Min-Capsule-01"},
      terracotta: {id: 44429356204327, sku: "Terra-Min-Capsule-01"},
      pacific: {id: 44429356237095, sku: "Pac-Min-Capsule-01"},
      arctic: {id: 44429356269863, sku: "Arc-Min-Capsule-01"},
      atlantic: {id: 44429356302631, sku: "Atl-Min-Capsule-01"},
      pine: {id: 44429356335399, sku: "Pine-Min-Capsule-01"},
      sage: {id: 44429356368167, sku: "Sage-Min-Capsule-01"},
      eucalyptus: {id: 44429356400935, sku: "Euca-Min-Capsule-01"},
      '5pm': {id: 44429356433703, sku: "5PM-Min-Capsule-01"},
      '6pm': {id: 44429356466471, sku: "6PM-Min-Capsule-01"},
      '7pm': {id: 44429356499239, sku: "7PM-Min-Capsule-01"},
      blush: {id: 44429356499239, sku: "7PM-Min-Capsule-01"},
      rosa: {id: 44429356499239, sku: "7PM-Min-Capsule-01"},
      plum: {id: 44429356499239, sku: "7PM-Min-Capsule-01"},
    },
    small: {
      charcoal: {id: 44484227793191, sku: "Char-Disc-Capsule-01"},
      petal: {id: 44484227825959, sku: "Petl-Disc-Capsule-01"},
      lavender: {id: 44484227858727, sku: "Lav-Disc-Capsule-01"},
      sand: {id: 44484227891495, sku: "Sand-Disc-Capsule-01"},
      terracotta: {id: 44484227924263, sku: "Terra-Disc-Capsule-01"},
      pacific: {id: 44484227957031, sku: "Pac-Disc-Capsule-01"},
      arctic: {id: 44484227989799, sku: "Arc-Disc-Capsule-01"},
      atlantic: {id: 44484228022567, sku: "Atl-Disc-Capsule-01"},
      pine: {id: 44484228055335, sku: "Pine-Disc-Capsule-01"},
      sage: {id: 44484228088103, sku: "Sage-Disc-Capsule-01"},
      eucalyptus: {id: 44484228120871, sku: "Euca-Disc-Capsule-01"},
      '5pm': {id: 44484228153639, sku: "5PM-Disc-Capsule-01"},
      '6pm': {id: 44484228186407, sku: "6PM-Disc-Capsule-01"},
      '7pm': {id: 44484228219175, sku: "7PM-Disc-Capsule-01"},
      blush: {id: 44484228219175, sku: "7PM-Disc-Capsule-01"},
      rosa: {id: 44484228219175, sku: "7PM-Disc-Capsule-01"},
      plum: {id: 44484228219175, sku: "7PM-Disc-Capsule-01"},
    }
  },
  sandbox: {
    large: {
      charcoal: {id: 46142539301164, sku: "Char-Larg-Capsule-01"},
      petal: {id: 46142539333932, sku: "Petl-Larg-Capsule-01"},
      lavender: {id: 46142539366700, sku: "Lav-Larg-Capsule-01"},
      sand: {id: 46142539399468, sku: "Sand-Larg-Capsule-01"},
      terracotta: {id: 46142539432236, sku: "Terra-Larg-Capsule-01"},
      pacific: {id: 46142539465004, sku: "Pac-Larg-Capsule-01"},
      arctic: {id: 46142539497772, sku: "Arc-Larg-Capsule-01"},
      atlantic: {id: 46142539530540, sku: "Atl-Larg-Capsule-01"},
      pine: {id: 46142539563308, sku: "Pine-Larg-Capsule-01"},
      sage: {id: 46142539596076, sku: "Sage-Larg-Capsule-01"},
      eucalyptus: {id: 46142539628844, sku: "Euca-Larg-Capsule-01"},
      '5pm': {id: 46142539661612, sku: "5PM-Larg-Capsule-01"},
      '6pm': {id: 46142539694380, sku: "6PM-Larg-Capsule-01"},
      '7pm': {id: 46142539727148, sku: "7PM-Larg-Capsule-01"},
      blush: {id: 46142539727148, sku: "7PM-Larg-Capsule-01"},
      rosa: {id: 46142539727148, sku: "7PM-Larg-Capsule-01"},
      plum: {id: 46142539727148, sku: "7PM-Larg-Capsule-01"},
    },
    medium: {
      charcoal: {id: 46142538121516, sku: "Char-Med-Capsule-01"},
      petal: {id: 46142538154284, sku: "Petl-Med-Capsule-01"},
      lavender: {id: 46142538187052, sku: "Lav-Med-Capsule-01"},
      sand: {id: 46142538219820, sku: "Sand-Med-Capsule-01"},
      terracotta: {id: 46142538252588, sku: "Terra-Med-Capsule-01"},
      pacific: {id: 46142538285356, sku: "Pac-Med-Capsule-01"},
      arctic: {id: 46142538318124, sku: "Arc-Med-Capsule-01"},
      atlantic: {id: 46142538350892, sku: "Atl-Med-Capsule-01"},
      pine: {id: 46142538383660, sku: "Pine-Med-Capsule-01"},
      sage: {id: 46142538416428, sku: "Sage-Med-Capsule-01"},
      eucalyptus: {id: 46142538449196, sku: "Euca-Med-Capsule-01"},
      '5pm': {id: 46142538481964, sku: "5PM-Med-Capsule-01"},
      '6pm': {id: 46142538514732, sku: "6PM-Med-Capsule-01"},
      '7pm': {id: 46142538547500, sku: "7PM-Med-Capsule-01"},
      blush: {id: 46142538547500, sku: "7PM-Med-Capsule-01"},
      rosa: {id: 46142538547500, sku: "7PM-Med-Capsule-01"},
      plum: {id: 46142538547500, sku: "7PM-Med-Capsule-01"},
    },
    mini: {
      charcoal: {id: 46142536745260, sku: "Char-Min-Capsule-01"},
      petal: {id: 46142536778028, sku: "Petl-Min-Capsule-01"},
      lavender: {id: 46142536810796, sku: "Lav-Min-Capsule-01"},
      sand: {id: 46142536843564, sku: "Sand-Min-Capsule-01"},
      terracotta: {id: 46142536876332, sku: "Terra-Min-Capsule-01"},
      pacific: {id: 46142536909100, sku: "Pac-Min-Capsule-01"},
      arctic: {id: 46142536941868, sku: "Arc-Min-Capsule-01"},
      atlantic: {id: 46142536974636, sku: "Atl-Min-Capsule-01"},
      pine: {id: 46142537007404, sku: "Pine-Min-Capsule-01"},
      sage: {id: 46142537040172, sku: "Sage-Min-Capsule-01"},
      eucalyptus: {id: 46142537072940, sku: "Euca-Min-Capsule-01"},
      '5pm': {id: 46142537105708, sku: "5PM-Min-Capsule-01"},
      '6pm': {id: 46142537138476, sku: "6PM-Min-Capsule-01"},
      '7pm': {id: 46142537171244, sku: "7PM-Min-Capsule-01"},
      blush: {id: 46142537171244, sku: "7PM-Min-Capsule-01"},
      rosa: {id: 46142537171244, sku: "7PM-Min-Capsule-01"},
      plum: {id: 46142537171244, sku: "7PM-Min-Capsule-01"},
    },
    small: {
      charcoal: {id: 46142537466156, sku: "Char-Disc-Capsule-01"},
      petal: {id: 46142537498924, sku: "Petl-Disc-Capsule-01"},
      lavender: {id: 46142537531692, sku: "Lav-Disc-Capsule-01"},
      sand: {id: 46142537564460, sku: "Sand-Disc-Capsule-01"},
      terracotta: {id: 46142537597228, sku: "Terra-Disc-Capsule-01"},
      pacific: {id: 46142537629996, sku: "Pac-Disc-Capsule-01"},
      arctic: {id: 46142537662764, sku: "Arc-Disc-Capsule-01"},
      atlantic: {id: 46142537695532, sku: "Atl-Disc-Capsule-01"},
      pine: {id: 46142537728300, sku: "Pine-Disc-Capsule-01"},
      sage: {id: 46142537761068, sku: "Sage-Disc-Capsule-01"},
      eucalyptus: {id: 46142537793836, sku: "Euca-Disc-Capsule-01"},
      '5pm': {id: 46142537826604, sku: "5PM-Disc-Capsule-01"},
      '6pm': {id: 46142537859372, sku: "6PM-Disc-Capsule-01"},
      '7pm': {id: 46142537892140, sku: "7PM-Disc-Capsule-01"},
      blush: {id: 46142537892140, sku: "7PM-Disc-Capsule-01"},
      rosa: {id: 46142537892140, sku: "7PM-Disc-Capsule-01"},
      plum: {id: 46142537892140, sku: "7PM-Disc-Capsule-01"},
    }
  }
}

const SHADOW_EXTENDER = {
  production: {
    charcoal: {id: 40519147192405, sku: "Char-Sys-Ext-01"},
    petal: {id: 40519147225173, sku: "Petl-Sys-Ext-01"},
    lavender: {id: 40519147257941, sku: "Lav-Sys-Ext-01"},
    sand: {id: 40519147290709, sku: "Sand-Sys-Ext-01"},
    terracotta: {id: 40519147323477, sku: "Terra-Sys-Ext-01"},
    pacific: {id: 40519147356245, sku: "Pac-Sys-Ext-01"},
    arctic: {id: 40519147389013, sku: "Arc-Sys-Ext-01"},
    atlantic: {id: 40519147421781, sku: "Atl-Sys-Ext-01"},
    pine: {id: 40519147454549, sku: "Pine-Sys-Ext-01"},
    sage: {id: 40519147487317, sku: "Sage-Sys-Ext-01"},
    eucalyptus: {id: 40519147520085, sku: "Euca-Sys-Ext-01"},
    '5pm': {id: 40519147552853, sku: "5PM-Sys-Ext-01"},
    '6pm': {id: 40519147585621, sku: "6PM-Sys-Ext-01"},
    '7pm': {id: 40519147618389, sku: "7PM-Sys-Ext-01"},
    blush: {id: 40700865019989, sku: "Blush-Sys-Ext-01"},
    rosa: {id: 40700865052757, sku: "Rosa-Sys-Ext-01"},
    plum: {id: 40700865085525, sku: "Plum-Sys-Ext-01"},
    almond: {id: 40724161757269, sku: "Almond-Sys-Ext-01"},
    clay: {id: 40724161790037, sku: "Clay-Sys-Ext-01"},
    mocha: {id: 40724161822805, sku: "Mocha-Sys-Ext-01"},
    cacao: {id: 40724161855573, sku: "Cacao-Sys-Ext-01"},
  
  },
  staging: {
    charcoal: {id: 44484160061735, sku: "Char-Sys-Ext-01"},
    petal: {id: 44484160094503, sku: "Petl-Sys-Ext-01"},
    lavender: {id: 44484160127271, sku: "Lav-Sys-Ext-01"},
    sand: {id: 44484160160039, sku: "Sand-Sys-Ext-01"},
    terracotta: {id: 44484160192807, sku: "Terra-Sys-Ext-01"},
    pacific: {id: 44484160225575, sku: "Pac-Sys-Ext-01"},
    arctic: {id: 44484160258343, sku: "Arc-Sys-Ext-01"},
    atlantic: {id: 44484160291111, sku: "Atl-Sys-Ext-01"},
    pine: {id: 44484160323879, sku: "Pine-Sys-Ext-01"},
    sage: {id: 44484160356647, sku: "Sage-Sys-Ext-01"},
    eucalyptus: {id: 44484160389415, sku: "Euca-Sys-Ext-01"},
    '5pm': {id: 44484160422183, sku: "5PM-Sys-Ext-01"},
    '6pm': {id: 44484160454951, sku: "6PM-Sys-Ext-01"},
    '7pm': {id: 44484160487719, sku: "7PM-Sys-Ext-01"},
    blush: {id: 40519147618389, sku: "Blush-Sys-Ext-01"},
    rosa: {id: 40519147618389, sku: "Rosa-Sys-Ext-01"},
    plum: {id: 40519147618389, sku: "Plum-Sys-Ext-01"},
  },
  sandbox: {
    charcoal: {id: 46142536024364, sku: "Char-Sys-Ext-01"},
    petal: {id: 46142536057132, sku: "Petl-Sys-Ext-01"},
    lavender: {id: 46142536089900, sku: "Lav-Sys-Ext-01"},
    sand: {id: 46142536122668, sku: "Sand-Sys-Ext-01"},
    terracotta: {id: 46142536155436, sku: "Terra-Sys-Ext-01"},
    pacific: {id: 46142536188204, sku: "Pac-Sys-Ext-01"},
    arctic: {id: 46142536220972, sku: "Arc-Sys-Ext-01"},
    atlantic: {id: 46142536253740, sku: "Atl-Sys-Ext-01"},
    pine: {id: 46142536286508, sku: "Pine-Sys-Ext-01"},
    sage: {id: 46142536319276, sku: "Sage-Sys-Ext-01"},
    eucalyptus: {id: 46142536352044, sku: "Euca-Sys-Ext-01"},
    '5pm': {id: 46142536384812, sku: "5PM-Sys-Ext-01"},
    '6pm': {id: 46142536417580, sku: "6PM-Sys-Ext-01"},
    '7pm': {id: 46142536450348, sku: "7PM-Sys-Ext-01"},
    blush: {id: 40519147618389, sku: "Blush-Sys-Ext-01"},
    rosa: {id: 40519147618389, sku: "Rosa-Sys-Ext-01"},
    plum: {id: 40519147618389, sku: "Plum-Sys-Ext-01"},
  }
}

const SHADOW_TILES = {
  production: {
    charcoal: {id: 40507974844501, sku: ""},
    petal: {id: 40507974877269, sku: ""},
    lavender: {id: 40507974910037, sku: ""},
    sand: {id: 40507974942805, sku: ""},
    terracotta: {id: 40507974975573, sku: ""},
    pacific: {id: 40507975008341, sku: ""},
    arctic: {id: 40507975041109, sku: ""},
    atlantic: {id: 40507975073877, sku: ""},
    pine: {id: 40507975106645, sku: ""},
    sage: {id: 40507975139413, sku: ""},
    eucalyptus: {id: 40507975172181, sku: ""},
    '5pm': {id: 40507975204949, sku: ""},
    '6pm': {id: 40507975237717, sku: ""},
    '7pm': {id: 40507975270485, sku: ""},
    blush: {id: 40700977872981, sku: ""},
    rosa: {id: 40700977905749, sku: ""},
    plum: {id: 40700977938517, sku: ""},
    almond: {id: 40724162183253, sku: ""},
    clay: {id: 40724162216021, sku: ""},
    mocha: {id: 40724162248789, sku: ""},
    cacao: {id: 40724162281557, sku: ""},

  },
  staging: {
    charcoal: {id: 44429420200231, sku: ""},
    petal: {id: 44429420232999, sku: ""},
    lavender: {id: 44429420265767, sku: ""},
    sand: {id: 44429420298535, sku: ""},
    terracotta: {id: 44429420331303, sku: ""},
    pacific: {id: 44429420364071, sku: ""},
    arctic: {id: 44429420429607, sku: ""},
    atlantic: {id: 44429420462375, sku: ""},
    pine: {id: 44429420495143, sku: ""},
    sage: {id: 44429420527911, sku: ""},
    eucalyptus: {id: 44429420560679, sku: ""},
    '5pm': {id: 44429420593447, sku: ""},
    '6pm': {id: 44429420626215, sku: ""},
    '7pm': {id: 44429420658983, sku: ""},
    blush: {id: 40700977872981, sku: ""},
    rosa: {id: 40700977905749, sku: ""},
    plum: {id: 40700977938517, sku: ""},
  },
  sandbox: {
    charcoal: {id: 46142540153132, sku: ""},
    petal: {id: 46142540185900, sku: ""},
    lavender: {id: 46142540218668, sku: ""},
    sand: {id: 46142540251436, sku: ""},
    terracotta: {id: 46142540284204, sku: ""},
    pacific: {id: 46142540316972, sku: ""},
    arctic: {id: 46142540349740, sku: ""},
    atlantic: {id: 46142540382508, sku: ""},
    pine: {id: 46142540415276, sku: ""},
    sage: {id: 46142540448044, sku: ""},
    eucalyptus: {id: 46142540480812, sku: ""},
    '5pm': {id: 46142540513580, sku: ""},
    '6pm': {id: 46142540546348, sku: ""},
    '7pm': {id: 46142540579116, sku: ""},
    blush: {id: 40700977872981, sku: ""},
    rosa: {id: 40700977905749, sku: ""},
    plum: {id: 40700977938517, sku: ""},
  }
}
const SHADOW_FLEX_TILES = {
  production: {
    charcoal: {id: 40617845096533, sku: "Char-Med-Tile-01"},
    petal: {id: 40617845129301, sku: "Petl-Med-Tile-01"},
    lavender: {id: 40617845162069, sku: "Lav-Med-Tile-01"},
    sand: {id: 40617845194837, sku: "Sand-Med-Tile-01"},
    terracotta: {id: 40617845227605, sku: "Terra-Med-Tile-01"},
    pacific: {id: 40617845260373, sku: "Pac-Med-Tile-01"},
    arctic: {id: 40617845293141, sku: "Arc-Med-Tile-01"},
    atlantic: {id: 40617845325909, sku: "Atl-Med-Tile-01"},
    pine: {id: 40617845358677, sku: "Pine-Med-Tile-01"},
    sage: {id: 40617845391445, sku: "Sage-Med-Tile-01"},
    eucalyptus: {id: 40617845424213, sku: "Euca-Med-Tile-01"},
    '5pm': {id: 40617845456981, sku: "5pm-Med-Tile-01"},
    '6pm': {id: 40617845489749, sku: "6pm-Med-Tile-01"},
    '7pm': {id: 40617845522517, sku: "7pm-Med-Tile-01"},
    blush: {id: 40700988031061, sku: "Blush-Med-Tile-01"},
    rosa: {id: 40700988063829, sku: "Rosa-Med-Tile-01"},
    plum: {id: 40700988096597, sku: "Plum-Med-Tile-01"},
    almond: {id: 40724161953877, sku: "Plum-Med-Tile-01"},
    clay: {id: 40724161986645, sku: "Plum-Med-Tile-01"},
    mocha: {id: 40724162019413, sku: "Plum-Med-Tile-01"},
    cacao: {id: 40724162052181, sku: "Plum-Med-Tile-01"},

  },
  staging: {
    charcoal: {id: 45052139864359, sku: "Char-Med-Tile-01"},
    petal: {id: 45052139897127, sku: "Petl-Med-Tile-01"},
    lavender: {id: 45052139929895, sku: "Lav-Med-Tile-01"},
    sand: {id: 45052139962663, sku: "Sand-Med-Tile-01"},
    terracotta: {id: 45052139995431, sku: "Terra-Med-Tile-01"},
    pacific: {id: 45052140028199, sku: "Pac-Med-Tile-01"},
    arctic: {id: 45052140060967, sku: "Arc-Med-Tile-01"},
    atlantic: {id: 45052140093735, sku: "Atl-Med-Tile-01"},
    pine: {id: 45052140126503, sku: "Pine-Med-Tile-01"},
    sage: {id: 45052140159271, sku: "Sage-Med-Tile-01"},
    eucalyptus: {id: 45052140192039, sku: "Euca-Med-Tile-01"},
    '5pm': {id: 45052140224807, sku: "5pm-Med-Tile-01"},
    '6pm': {id: 45052140257575, sku: "6pm-Med-Tile-01"},
    '7pm': {id: 45052140290343, sku: "7pm-Med-Tile-01"},
    blush: {id: 40700988031061, sku: "Blush-Med-Tile-01"},
    rosa: {id: 40700988063829, sku: "Rosa-Med-Tile-01"},
    plum: {id: 40700988096597, sku: "Plum-Med-Tile-01"},
  },
  sandbox: {
    charcoal: {id: 46142512988460, sku: "Char-Med-Tile-01"},
    petal: {id: 46142513021228, sku: "Petl-Med-Tile-01"},
    lavender: {id: 46142513053996, sku: "Lav-Med-Tile-01"},
    sand: {id: 46142513086764, sku: "Sand-Med-Tile-01"},
    terracotta: {id: 46142513119532, sku: "Terra-Med-Tile-01"},
    pacific: {id: 46142513152300, sku: "Pac-Med-Tile-01"},
    arctic: {id: 46142513185068, sku: "Arc-Med-Tile-01"},
    atlantic: {id: 46142513217836, sku: "Atl-Med-Tile-01"},
    pine: {id: 46142513250604, sku: "Pine-Med-Tile-01"},
    sage: {id: 46142513283372, sku: "Sage-Med-Tile-01"},
    eucalyptus: {id: 46142513316140, sku: "Euca-Med-Tile-01"},
    '5pm': {id: 46142513348908, sku: "5pm-Med-Tile-01"},
    '6pm': {id: 46142513381676, sku: "6pm-Med-Tile-01"},
    '7pm': {id: 46142513414444, sku: "7pm-Med-Tile-01"},
    blush: {id: 40700988031061, sku: "Blush-Med-Tile-01"},
    rosa: {id: 40700988063829, sku: "Rosa-Med-Tile-01"},
    plum: {id: 40700988096597, sku: "Plum-Med-Tile-01"},
  }
}

selectizeHelper = {
  render:  {
    no_results: function() {
      return `<div class="no-results"><button class="add-tag-btn" type="button">Create New Label ($2)</button></div>`;
    },
    option_create: function() {
      
      // FREECUSTOMIZATION -- change this to make it free
      // return '<div class="create">Create New Label (<s>$4</s>&nbsp;FREE)</div>';
      // return '<div class="create">Create New Label ($2)</div>';
      return '<div class="create">Create New Label ($4)</div>';
    }
  }
}

function waitForVideoJs() {
  const videoJsLoaded = $('video-js').toArray().every((el) => $(el).find('video').length)

  if (videoJsLoaded) {
    loadHlsVideos()
  }
}
$(document).on('DOMNodeInserted', 'video-js video', waitForVideoJs)

function loadHlsVideos() {
  $('video-js, video[autoplay][muted][loop]').each(function () {
    const self = $(this);
    const video = self.prop("tagName") === "video" ? self[0] : self.find('video')[0]
    const videoSrc = self.data('src');
    if (!videoSrc || !Hls.isSupported()) return;

    const hls = new Hls();
    hls.loadSource(videoSrc);
    hls.attachMedia(video);
  })
}

function BaSGetDiscount(price) {
  const rule = BaSDiscountRules.find((curRule) => price >= curRule.minPrice)
  return rule;
}

// Quick add to cart
// $('.quick-add-to-cart').click(async (e) => {
//   console.log('quick-add-to-cart')
//   const itemEl = $(e.target).closest('[data-hash_name]')
//   const color = itemEl.find('.custom-home-shop-itemColorButton.active').data('color-value')
//   const addtocart_location = itemEl.data('addtocart_location') ? itemEl.data('addtocart_location') : 'quick_add_to_cart'
//   console.log('location', addtocart_location)
//   const recommendationsSingleLabel = itemEl.data('recommendations_single_label')
//   const variantId = itemEl.find('.product-variants option').toArray().find((el) => $(el).text().includes(color)).value
//   const item = {id: variantId, quantity: 1}
//   if (recommendationsSingleLabel) {
//     item.properties = {
//       "Custom Label": "",
//       "Customization Cost": "",
//       "Label": recommendationsSingleLabel,
//       "_add_source": addtocart_location
//     }
//   }else {
//     item.properties = {
//       "_add_source": addtocart_location
//     }
//   }

//   data = {items: [item]}
//   addShadowProducts(data, item, itemEl, color)
//   await theme.cart.clearCartIfHasCorporateGifts()
//   theme.cart.addItemFromForm(data)

//   function addShadowProducts(data, product, itemEl, color) {
//     const hashName = itemEl.attr('data-hash_name')
//     if (hashes_for_skipping_shadow_products.includes(hashName)) return
  
//     const capsuleCount = Number(itemEl.attr('data-cpsl_cnt'))
//     const tilesCount = Number(itemEl.attr('data-tile_cnt'))
//     const presetLabels = itemEl.attr('data-labels').split(',')
//     const presetSizes = itemEl.attr('data-sizes').split(',')
//     const count = tilesCount || capsuleCount
//     const cartItems = theme.cart.data.items
//     const existingInCart = cartItems.find((item) => {
//       const defaultProps = { Timestamp: ""}
//       const itemProps = JSON.stringify({...item.properties, ...defaultProps})
//       const productProps = JSON.stringify({...product.properties, ...defaultProps})
//       return  Number(product.id) === Number(item.id) && itemProps === productProps
//     })
  
//     product.properties ||= {}
//     product.properties['Timestamp'] = existingInCart?.properties?.Timestamp || new Date().getTime()
//     if (!count) return
  
//     const { items } = data
//     for (let i = 1; i <= count; i++) {
//       properties = {
//         'Product': hashName,
//         'Color': color,
//         'Label': presetLabels[i - 1].trim(),
//         'Custom Label': "",
//         'Parent Timestamp': product.properties['Timestamp']
//       }
//       const size = presetSizes[i - 1] ? presetSizes[i - 1].toLowerCase() : defaulf_size.toLowerCase()
//       const shadowProductId = getShadowProduct(capsuleCount ? 'capsule' : 'tile', properties['Color'], size)?.id
//       const item = {id: shadowProductId, quantity: Number(product.quantity), properties}
//       const existingItem = existingShadowProductItem(item, items)
//       if (existingItem)
//         existingItem.quantity += Number(product.quantity)
//       else 
//         items.push(item)
//     }
//     items.forEach((el) => el.properties && el.properties['Parent Timestamp'] === product.properties['Timestamp'] && (el.properties['Quantity'] = el.quantity / product.quantity))
//   }
// })

$(document).ready(() => {
  $('.new-home-animation-header .card').on('click', function() {
    const index = $(this).data('index')
    $('.new-home-animation-header .card').removeClass('active')
    $(this).addClass('active')
    $('.new-home-animation-content').removeClass('active')
    $(`.new-home-animation-content[data-index="${index}"]`).addClass('active').find('video').get(0).play()
  })

  $.fn.onClassChange = function(cb) {
    return $(this).each((_, el) => {
      new MutationObserver(mutations => {
        mutations.forEach(mutation => cb && cb(mutation.target, $(mutation.target).prop(mutation.attributeName)));
      }).observe(el, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  $('.play-on-intersection').each(function () {
    const observer = new IntersectionObserver(entries => {
      entries.filter(e => e.isIntersecting).forEach(entry => {
        entry.target.play()
        observer.disconnect();
      })
    })
    observer.observe(this)
  })

  function scrollToQuestion() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const questionId = urlSearchParams.get('id');
    const distanceToTop = 50
  
    if (questionId) {
      const questionElement = $(`#${questionId}`);
      if (!questionElement.length) return

      const animationPromise = new Promise(resolve => {
        $('html, body').animate(
          {
            scrollTop: questionElement.offset().top - distanceToTop
          },
          {
            duration: 500,
            complete: resolve
          }
        );
      });
  
      animationPromise.then(() => {
        questionElement.find('.custom-faq-gradient-block-content-item-qa-question').click();
      });
    }
  }
  scrollToQuestion()

  onHoverVideoPlay = (e, curVideo) => {
    const video = $(e.target).closest('.common-videojs-block')
    curVideo.play()
    $(e.target).closest('.customer-photo, .card_img, .image, .double_image, .video').find('.image__card__text__hover').hide();
    video.addClass('active')
    $(e.currentTarget).find('image__card__text__hover').addClass('disabled');
  }

  onHoverVideoPause = (e, curVideo) => {
    const video = $(e.target).closest('.common-videojs-block')
    curVideo.pause()
    $(e.target).closest('.customer-photo, .card_img, .image, .double_image, .video').find('.image__card__text__hover').show();
    video.removeClass('active')
    $(e.currentTarget).find('image__card__text__hover').removeClass('disabled');
  }

  $(document).on('pointerenter', '.play-video-on-hover', (e) => {
    if (!isDesktop()) return

    const curVideo = findVideo(e.target)
    if (curVideo.paused) {
      onHoverVideoPlay(e, curVideo)
    }
  })

  $(document).on('pointerleave', '.play-video-on-hover', (e) => {
    if (!isDesktop()) return

    const curVideo = findVideo(e.target)
    if (!curVideo.paused) {
      onHoverVideoPause(e, curVideo)
    }
  })

  $(document).on('touchstart', '.play-video-on-hover', (e) => {
    if (isDesktop()) return

    const curVideo = findVideo(e.target)
    if (curVideo.paused) return onHoverVideoPlay(e, curVideo)

    onHoverVideoPause(e, curVideo)
  })

  function findVideo(item) {
    const video = $(item).closest('.common-videojs-block')
    return video.find('video').get(0);
  }

  $(document).on('click', '.common-videojs-block .Play', function (e) {
    $('.common-videojs-block .Pause').click()
    const curVideo = findVideo(e.target);
    if (curVideo.paused) {
      curVideo.play()
    }
    $(this).removeClass('active')
    $(this).prev().addClass('active')
  })

  $(document).on('click', '.common-videojs-block .Pause', function (e) {
    const curVideo = findVideo(e.target);
    if (!curVideo.paused) {
      curVideo.pause()
    }
    $(this).removeClass('active')
    $(this).next().addClass('active')
  })

  $(document).on('click', '.common-videojs-block .mute, .common-videojs-block .unmute', function (e) {
    const curVideo = findVideo(e.target);
    curVideo.muted = !curVideo.muted;
    $(this).removeClass('active')
    if ($(this).hasClass('mute')) {
      $(this).prev().addClass('active')
    } else {
      $(this).next().addClass('active')
    }
  })

  $(document).on('click', '.custom-faq-gradient-block-content-item-qa-question', function() {
    const qa = $(this).parent().toggleClass('active');
    const qaIsActive = qa.hasClass('active')
    const rowHeigth = qa.find('.custom-faq-gradient-block-content-item-qa-answer-row').outerHeight()
    qa.find('.custom-faq-gradient-block-content-item-qa-answer').css('max-height', qaIsActive ? rowHeigth : 0)
    const parentId = qa.attr('id');
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('id', parentId);
    window.history.pushState({}, '', `${window.location.pathname}?${urlSearchParams.toString()}`);
  });

  // Subpage/QuickShop
  $('.quick-view-button').click(function (e) {
    const handle = $(this).data('handle')
    const title = $(this).data('title')
    openQuickShop(handle, title, e)
    return false
  });
  $(document).on('click', '.open-in-bas', function() {
    const bundleLabels = $('.premade-labels select')?.toArray().map((el) => $(el).data('selectize').getValue())
    const bundleColors = $('.color-dropdown select')?.toArray().map((el) => $(el).data('selectize').getValue())
    const data = {
      product_handle: $(this).attr('data-handle'),
      color: $('.quick-shop-content [name="Color"]:checked').val() || '',
      bundleLabels: bundleLabels.length ? bundleLabels : '',
      bundleColors: bundleColors.length ? bundleColors : ''
    }
    
    window.location.href = `${BaS_path}?&${$.param(data)}`
  });
  $('.subpage, .quick-shop').click(function(e) {
    if (!$(e.target).closest('.back-button').length && !$(e.target).hasClass('quick-shop') && !$(e.target).hasClass('subpage')) return
    $('.subpage, .quick-shop').removeClass('active')
    $('#shopify-section-cad-header').show()
    $('body').removeClass('modal-open')
    $('.subpage-video-block-controls-icon-pause').click()
    $('.quick-shop').removeClass('above_cart')
    $('.quick-shop .quick-shop-content > div').remove()
  });
  $('.subpage-video-block-controls-icon-play').click((e) => {
    videojs('#subpage-video').play()
    $(e.currentTarget).hide().next().css('display', 'flex');
  });
  $('.subpage-video-block-controls-icon-pause').click((e) => {
    videojs('#subpage-video').pause()
    $(e.currentTarget).hide().prev().css('display', 'flex');
  });

  // Video
  (function() {
    const video = $('#common-video-block video').get(0);
    if (!video) return;
    
    $('.common-video-block-controls > div').click(function() {
      video.paused ? video.play() : video.pause();
      $('#common-video-block').toggleClass('active');
    });

    $(video).click(function() {
      $('#common-video-block').addClass('clicked');
      setTimeout(() => {
        $('#common-video-block').removeClass('clicked');
      }, 2000);
    });

  })();

  $('#SearchModal').click(function(e) {
    if(e.target !== this) return;

    $(this).find('.js-modal-close').click()
  })

  updateCalculatorContent();
  // Contact subscribed --------->
  const contactSubscribed = new URL(window.location.href).searchParams.get('customer_posted') === 'true';
  if (contactSubscribed) {
    $('.form-contact-subscribe-container').addClass('subscribed');
  }
  // <--------------- Contact subscribed

  // featured slider ---------->
  if($('.swiper-container.featured').length > 0) initFeaturedSlider();
  // <---------- featured slider

  // instagram slider ---------->
  if($('[data-instagram-swiper]').length > 0) initInstagramMobileSwiper();
  // <---------- instagram slider

  // shop --------------->
  // $('.custom-home-shop-itemColors').click(function(e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  // })
  // $('.custom-home-shop-itemColorButton'). click(function(e) {
  //   console.log('custom-home-shop-itemColorButton clicked');
  //   e.preventDefault();
  //   e.stopPropagation();
  //   const item = $(this).closest('.custom-home-shop-item');
  //   $(item.find('.custom-home-shop-itemColorButton')).removeClass('active');
  //   $(this).addClass('active');
  //   //get the name of the color from this data-color-value
  //   const color = $(this).data('color-value');
  //   // console.log('home shop item color clicked is ', color);
    
  //   let images
  //   if ($(item).attr('data-product_handle') === 'xxxthe-days-of-the-week') {
  //     images = item.find('.custom-home-shop-itemImage.color-preview').map((i, image) => {
  //       if ((i + 1) % 3 == 0) {
  //         return image
  //       }
  //     });
  //   } else {
  //     images = item.find('.custom-home-shop-itemImage.color-preview');
  //   }
  //   //=== new way 
  //   images.removeClass('active');
  //   $(images).filter(`.color${color}`).addClass('active');

  //   setPreSelectedLabel()
  // })
// <---------------- shop

  let calculatorPrevValue = $('select[data-calculator-selectize]').find('option[selected]').val();
  let calculatorSelectize;
  $('select[data-calculator-selectize]').length && $('select[data-calculator-selectize]').selectize({
    delimiter: ',',
    persist: false,
    create: false,
    onInitialize: function() {
      calculatorSelectize = this;
    },
    onChange: function (value) {
      if(!value) return

      updateCalculatorContent(value);
      calculatorPrevValue = value
    },
    onDropdownOpen: function() {
      calculatorSelectize.clear()
      calculatorSelectize.$control_input.focus()
    },
    onBlur: function() {
      if(!calculatorSelectize.items.length)
        calculatorSelectize.setValue(calculatorSelectize.search(calculatorPrevValue).items[0].id)
      $('.product__calculatorDropdownWrapper').removeClass('active')
    }
  });

  $('.product__calculatorDropdownWrapper').click(function() {
    $(this).addClass('active')
    $(this).find('select[data-calculator-selectize]').data('selectize')?.open()
  })

  $(window).on('resize', function(){
    initRecommendations()
  })

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  (function () {
    const $impactTitle = $('.impact_calculator .top_content .title')
    if (!$impactTitle.length) return

    const startDate = '04/25/2023'
    
    const firstDay = new Date(startDate);
    const currentDay = new Date();
    
    const diffInDays = Math.floor((currentDay - firstDay) / (1000 * 60 * 60 * 24));
    $impactTitle.text(numberWithCommas(Math.floor(initial_number_of_capsules + average_number_of_capsules_sold_per_day * diffInDays)));
  }());
});

$('.impact_calculator .close').click((e) => {
  $(e.currentTarget).closest('.impact_calculator').removeClass('active')
})
$('.impact_calculator').click((e) => {
  if ($(e.target).hasClass('close')) return

  $(e.currentTarget).addClass('active')
}).hover((e) => $(e.currentTarget).addClass('active'), (e) => $(e.currentTarget).removeClass('active'))

function parseLabel(label) {
  // Do not display preview for the blank label
  if (label.toLowerCase() === '*blank label*') return '';

  const { length } = label;
  const limitPerRow = 11;
  if (length <= limitPerRow) return label;

  const x = "7%";
  const dy1 = "-15";
  const dy2 = "25";
  const fontSize = "30";
  const separator = ' ';
  const [part1, part2] = getLabelRows(separator, label, limitPerRow);
  return `
    <tspan x="${x}" dy="${dy1}" font-size="${fontSize}">${part1}</tspan>
    <tspan x="${x}" dy="${dy2}" font-size="${fontSize}">${part2.substring(0, 11)}</tspan>
  `;
}

function getLabelRows(separator, label, limitPerRow) {
  const parts = label.split(separator);
  let part1 = parts[0];
  let part2 = parts.slice(1).join(separator);
  
  if (part1.length > limitPerRow || part2.length > limitPerRow) {
    part1 = label.substring(0, limitPerRow);
    part2 = label.substring(limitPerRow);
  }
  
  return [part1, part2];
}

function initRecommendations() {
  const section = $(".product-recommendations");
  if (section === null) return;

  section.find('.custom-home-shop-item').removeClass('hidden')
  const productId = section.data('productId');
  const desktopPerRow = 3
  const limit = isDesktop() ? desktopPerRow : section.data('limit')
  if (productId) {
    const elemToHide = section.find(`.custom-home-shop-item[data-product-id='${productId}']`);
    if (elemToHide) elemToHide.addClass('hidden');
  }
  const blocks = section.find('.custom-home-shop-item:not(.hidden)').get()
  if (blocks.length <= limit) return;

  const arr = [];
  while(arr.length < limit){
    const r = Math.floor(Math.random() * blocks.length);
    if(arr.indexOf(r) === -1) {
      arr.push(r);
    }
  }

  blocks.forEach(function(elem, idx) {
    if (!arr.includes(idx)) $(elem).addClass('hidden')
  })
}

function callInfoModal(msg, header) {
  $('.info-msg-content').html(msg);
  $('.info-msg-header').html(header);
  $('.js-modal-open-info-msg-modal').click();
}

async function addToCart(id, quantity = 1) {
  await theme.cart.clearCartIfHasCorporateGifts()
  return $.post('/cart/add.js', { id, quantity }).then(() => {
    $.get('/cart.js').then(res => $('body').trigger('updateCart', res));
  })
}

function initFeaturedSlider() {
  featuredSwiper = new Swiper ('.swiper-container.featured', {
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    keyboard: true,
    freeMode: false,
    threshold: 1,
    longSwipes: false,
    slidesPerRow: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: true
    }
  });

  const featuredBlocks = $('.custom-home-featured-block-content-header > div');
  featuredBlocks.click(function() {
    featuredSwiper.slideTo(featuredBlocks.index($(this)));
  });

  featuredSwiper.on('slideChange', function () {
    const { activeIndex } = featuredSwiper;
    featuredBlocks.removeClass('active');
    $(featuredBlocks[activeIndex]).addClass('active');
  });
}

function initInstagramMobileSwiper() {
  new Swiper ('[data-instagram-swiper]', {
    observer: true,
    observeParents: true,
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });
}


function existingShadowProductItem(newItem, items) {
  return items.find((el) =>  Number(el.id) === Number(newItem.id) && JSON.stringify({ ...el.properties, Quantity: 1 }) === JSON.stringify({ ...newItem.properties, Quantity: 1 }))
}

// disable submit product form on "Enter"
$('form.product-single__form').on("keydown", event => { return event.key !== "Enter"; });

$(document).on('click', '.expand-trigger', function(e) {
  const $el = $(this);
  const wrapper = $el.closest('.expand-wrapper');
  if (wrapper.hasClass('disabled')) return;

  $el.toggleClass('active');
  $el.next().slideToggle(500);
})


$('[data-calculator-trigger]').click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  if (isBaS) {
    $('.js-modal-open-capsule-calculator-BaS').click()
    return;
  }
  $('.product__calculator-wrapper').toggleClass('active');
  $('body').toggleClass('modal-open');
});

$('.product__calculator-wrapper').click(function(e) {
  if(e.target !== this) return;

  $(this).find('[data-calculator-trigger]').click();
})

function isDesktop() {
  return window.innerWidth > 768;
}

function updateCalculatorContent() {
  $('.product__calculator').each((i, el) => {
    const contentSelect = $(el).find('select[data-type="calculator-content"]').find('option:selected').val();
    $(el).find('[data-calculator-content]').removeClass('active');
    $(el).find(`[data-calculator-content][data-content="${contentSelect}"]`).addClass('active');
    $(el).find('[data-calculator-select-value]').html(`${contentSelect}&nbsp;<span>&#9660;</span>`)
  })
}

document.addEventListener('scroll', (e) => {
  $('video.lazy').toArray().map((video) => {
    for (const source in video.children) {
      const videoSource = video.children[source];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.dataset.src;
      }
    }
    video.load();
    video.classList.remove("lazy");
  })
});

$(document).on('keyup', 'textarea', (e) => {
  const target = $(e.target);
  const maxLength = target.attr('maxlength');
  const currentLength = target.val().length;

  target.parent().find('.textarea-counter').html(`${maxLength - currentLength} characters remaining`);
})

function getShadowProduct(type, color, size) {
  const getConstant = (argType, argSize) => {
    if (argSize === "extender") return SHADOW_EXTENDER[shopify_env]
    if (argType === "capsule") return SHADOW_CAPSULES[shopify_env]
    if (argType === "tile") return SHADOW_TILES[shopify_env]
    if (argType === "flex_tile") return SHADOW_FLEX_TILES[shopify_env]
    return SHADOW_EXTENDER[shopify_env]
  }
  const sizeLowCase = size.toLowerCase()
  product = getConstant(type, size)
  if (product[sizeLowCase]) product = product[sizeLowCase]
  return product[color.toLowerCase().trim()]
}

function openSubpage({title, copy, poster, subtitle, videoUrl}) {
  const subpage = $('.subpage')
  subpage.addClass('active')
  subpage.find('.title').text(title)
  subpage.find('.subtitle').text(subtitle)
  subpage.find('.copy').text(copy)
  videojs('#common-video0subpage').poster(poster)
  videojs('#common-video0subpage').src(videoUrl)
  $('#shopify-section-cad-header').hide()
  $('body').addClass('modal-open')
}

function openQuickShop(handle, title, e) {
  const quickShop = $('.quick-shop')
  const openInBaSText = "Edit this bundle in our customizer"
  quickShopContent = quickShop.find('.quick-shop-content')
  $('.quick-shop').attr('class', `quick-shop active template-product page-${handle} page-${title.replaceAll(' ', '_').toLowerCase()}`)
  $('#shopify-section-cad-header').hide()
  $('body').addClass('modal-open')
  quickShopContent.html('<center>Loading...</center>')
  mainGallerySwiper = undefined

  if (e && $(e.target).closest("#CartDrawer").length) {
    quickShop.addClass('above_cart')
  }

  $.get(`/products/${handle}?sections=product-template`).then(res => {
    quickShopContent.html(res['product-template'])
    initProductLabelsJS()
    initProductsJS()
    sections.register('.quick-shop', theme.Product);
    // not needed yet, may need to be added only for new products
    // quickShopContent.find('.options-area').after(`<div class="open-in-bas" data-handle="${handle}">${openInBaSText}</div>`)
    quickShopContent.scrollTop(0)
    prevPDPOffset = 0;
    currentOffset = 0;
  });
}

function getNewBaSName(name) {
  if (name === "Small") return "The 56"
  if (name === "Medium") return "The 132"
  if (name === "Large") return "The 275"
  if (name === "Extender") return "The Extender"
  return "The Flex Tile"
}

typeof Selectize != 'undefined' && Selectize.define(starterLabelSelectizeBaSPlugin, function () {
  const self = this;
  const { setup } = self;
  this.setup = function () {
    setup.apply(self, arguments);
    // Intercept default handlers
    self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown', '[data-selectable]', function (e) {
      const $target = $(e.currentTarget)
      const value = $target.data('value');
      if (self.items.indexOf(value) !== -1) {
        e.preventDefault();
        e.stopPropagation();
        self.removeItem(value);
        $target.removeClass('selected')
        return false;
      }
      return self.onOptionSelect.apply(self, arguments);
    });
  }
})

function dataURItoBlob (dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  const [uriFirstPart, uriSecondPart] = dataURI.split(',')
  const byteString = uriFirstPart.indexOf('base64') >= 0 ? atob(uriSecondPart) : unescape(uriSecondPart)
  
  const mimeString = uriFirstPart.split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {type: mimeString});
}

window.sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}
const password = "GOODY0723";

function showAlert() {
  if (window.location.pathname === "/pages/goody") {
    const inputPassword = prompt("Enter password:");

    if (inputPassword === password) {
    } else {
      alert("Wrong password");
      showAlert()
    }
  }
}
showAlert()

function getCookie(name) {
  const cookieName = name + "=";
  const cookieArray = document.cookie.split(';');
  for (const cookie of cookieArray) {
    let trimmedCookie = cookie.trim();
    if (trimmedCookie.indexOf(cookieName) === 0) {
      return trimmedCookie.substring(cookieName.length, trimmedCookie.length);
    }
  }
  return null;
}

function isReturningCustomer() {
  const discountCode = getCookie("discount_code");
  return discountCode === "COMMUNITYHAT";
}

function setPreSelectedLabel() {
  $('.cart_recommendations_items .custom-home-shop-item').each((index, item) => {
    const label = $(item).attr('data-recommendations_single_label')
    if (label) {
      const color = $(`[data-recommendations_single_label=${label}] .custom-home-shop-itemColors .active`).attr('data-color-value')
      const span = $(`.preselected-labels-main > span.label`) 
      const img = $(`#${label}-${labelColorsByColor[color]}`).clone();
      const image = $(`<img src="${$(img).attr('xlink:href')}" class="preselected-image">`);
      span.html('')
      image.appendTo(span);
    }
  })
}
setPreSelectedLabel() 

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

